import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _styled from "@emotion/styled-base";
import _get from "lodash/fp/get";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import { useConfig, useCurrentDoc, useDocs } from 'docz';
import { Link } from 'gatsby';
import * as styles from 'gatsby-theme-docz/src/components/NavLink/styles';
import React from 'react';
import { jsx } from 'theme-ui';
import { link } from './custom-styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Container = _styled("div", {
  target: "ex7swxv0"
})(process.env.NODE_ENV === "production" ? {
  name: "eg4h5",
  styles: "a{transition:opacity 0.2s ease;&:hover{opacity:0.75;}}"
} : {
  name: "eg4h5",
  styles: "a{transition:opacity 0.2s ease;&:hover{opacity:0.75;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var getHeadings = function getHeadings(route, docs) {
  var doc = docs.find(function (item) {
    return item.route === route;
  });

  var headings = _get('headings', doc);

  return headings ? headings.filter(function (heading) {
    return heading.depth === 2;
  }) : [];
};

var getCurrentHash = function getCurrentHash() {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location ? decodeURI(window.location.hash) : '';
};

export var NavLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var item = _ref.item,
      props = _objectWithoutPropertiesLoose(_ref, ["item"]);

  var _useConfig = useConfig(),
      themeConfig = _useConfig.themeConfig;

  var docs = useDocs();
  var current = useCurrentDoc();

  if (item.hidden) {
    return null;
  }

  var to = item.route;
  var headings = docs && getHeadings(to, docs);
  var isCurrent = item.route === current.route;
  var showHeadings = !_get('menu.headings.rightSide', themeConfig, false) && isCurrent && headings && headings.length > 0;
  var currentHash = getCurrentHash();
  return jsx(Container, null, jsx(Link, _extends({}, props, {
    to: to,
    sx: _objectSpread(_objectSpread({}, styles.link), {}, {
      my: 0,
      padding: '.4rem 1.5rem',
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: '400'
    }),
    activeClassName: "active",
    ref: ref
  })), showHeadings && headings.map(function (heading) {
    return jsx(Link, {
      key: heading.slug,
      to: to + "#" + heading.slug,
      sx: _objectSpread(_objectSpread({}, styles.smallLink), {}, {
        my: 0,
        padding: '.4rem 1.5rem',
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: '400'
      }),
      className: currentHash === "#" + heading.slug ? 'active' : ''
    }, heading.value);
  }));
});

if (typeof NavLink !== 'undefined' && NavLink && NavLink === Object(NavLink) && Object.isExtensible(NavLink) && !NavLink.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NavLink, '__filemeta', {
    configurable: true,
    value: {
      name: "NavLink",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/NavLink/index.js"
    }
  });
}